import { render, staticRenderFns } from "./HeaderFlag.vue?vue&type=template&id=6fa7c4bf&scoped=true&"
import script from "./HeaderFlag.vue?vue&type=script&lang=js&"
export * from "./HeaderFlag.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFlag.vue?vue&type=style&index=0&id=6fa7c4bf&prod&lang=scss&"
import style1 from "./HeaderFlag.vue?vue&type=style&index=1&id=6fa7c4bf&prod&scoped=true&lang=scss&"
import style2 from "./HeaderFlag.vue?vue&type=style&index=2&id=6fa7c4bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7c4bf",
  null
  
)

export default component.exports